import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";


const FileList = ({ files = [], title }) => {
  if (!files.length) return null;

  // ✅ Updated download handler (per file)
  const handleDownload = async (e, file) => {
    e.stopPropagation();

    const documentUrl = file.url;
    if (!documentUrl) return;

    try {
      const response = await fetch(documentUrl, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Extract filename
      const urlParts = documentUrl.split("/");
      const lastPart = urlParts[urlParts.length - 1];
      const fileNameWithoutParams = lastPart.split("?")[0];
      const nameWithoutExt = fileNameWithoutParams.split(".")[0];

      // fallback to filename from DB
      const certName = nameWithoutExt || file.filename;

      const contentType = blob.type;
      const extension =
        contentType?.split("/")[1] || documentUrl.split(".").pop() || "png";

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${certName}.${extension}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);

      // fallback (important for S3 private/CORS issues)
      window.open(documentUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      {/* Title */}
      {title && (
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {files.map((file, index) => (
          <Box
            key={`${index}-${file.filename}`}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.2,
              py: 0.6,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 5,
              maxWidth: 260,
              minWidth: 180,
            }}
          >
            {/* File Name */}
            <Typography
              variant="caption"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1, // 🔥 takes remaining space
                mr: 0.5,
              }}
            >
              {file.filename}
            </Typography>

            {/* Icons Group */}
            <Box sx={{ display: "flex", gap: 0.3 }}>
              {/* View */}
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(file.url, "_blank");
                }}
                sx={{
                  color: "primary.main",
                  p: 0.5, // 🔥 tighter click area
                }}
              >
                <VisibilityIcon fontSize="inherit" />
              </IconButton>

              {/* Download */}
              <IconButton
                size="small"
                onClick={(e) => handleDownload(e, file)}
                sx={{
                  color: "success.main",
                  p: 0.5, // 🔥 tighter
                }}
              >
                <DownloadIcon fontSize="inherit" />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FileList;
